/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from 'react';
import {Grid, LinearProgress, Typography} from "@mui/material";

interface LoadingComponent {
    fullHeight?: boolean
}

const Loading = ({fullHeight = false}: LoadingComponent) => {

    return (
        <Grid container
              minHeight={fullHeight ? '80vh' : 'inherit'}
              sx={{
                  position: fullHeight ? 'inherit' : 'absolute',
                  zIndex: fullHeight ? 0 : 10
              }}
              alignContent="baseline">
            <Grid item xs={12}>
                <LinearProgress color="secondary"/>
            </Grid>
            {fullHeight &&
                <Grid item xs={12} textAlign="center">
                    <Typography variant="subtitle2">Data Loading...</Typography>
                </Grid>
            }
        </Grid>
    )
}


export default Loading;